/**
 * Módulo: Hero Slider
 * Swiper com autoplay, fade, dots mobile, setas desktop.
 */

import Swiper from 'swiper';
import { Autoplay, Pagination, Navigation, EffectFade } from 'swiper/modules';

export function initHero() {
  const el = document.querySelector('.hero-slider__swiper');
  if (!el) return;

  new Swiper(el, {
    modules: [Autoplay, Pagination, Navigation, EffectFade],

    effect: 'fade',
    fadeEffect: { crossFade: true },

    loop: true,

    autoplay: {
      delay: 4000,
      disableOnInteraction: false,
      pauseOnMouseEnter: true,
    },

    pagination: {
      el: '.hero-slider__dots',
      clickable: true,
    },

    navigation: {
      prevEl: '.hero-slider__btn--prev',
      nextEl: '.hero-slider__btn--next',
    },

    a11y: {
      prevSlideMessage: 'Slide anterior',
      nextSlideMessage: 'Próximo slide',
    },
  });
}
